module.exports = __webpack_public_path__ + "img/docs-x-close.254b6eae.svg";